export function formatBytes(bytes: number, precision = 1): string {
  if (!Number.isFinite(bytes) || bytes <= 0) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
  const index = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  const value = bytes / 1024 ** index;
  return `${value.toFixed(index === 0 ? 0 : precision)} ${units[index]}`;
}

export function formatDuration(seconds: number, compact = false): string {
  if (!Number.isFinite(seconds) || seconds < 0) return '0m';
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remaining = Math.floor(seconds % 60);
  if (compact) return hours ? `${hours}h ${minutes}m` : `${minutes}m`;
  return hours ? `${hours}:${String(minutes).padStart(2, '0')}:${String(remaining).padStart(2, '0')}` : `${minutes}:${String(remaining).padStart(2, '0')}`;
}

export function formatPercent(value: number, total: number, precision = 1): string {
  if (total <= 0) return '0%';
  const percent = value / total * 100;
  const smallest = 10 ** -precision;
  if (percent > 0 && percent < smallest) return `<${smallest.toFixed(precision)}%`;
  return `${percent.toFixed(precision)}%`;
}

export function formatDate(value: string | null): string {
  if (!value) return 'Not recorded';
  if (/^\d{4}$/.test(value)) return value;
  if (/^\d{4}-\d{2}$/.test(value)) {
    const month = Number(value.slice(5));
    if (month < 1 || month > 12) return value;
    return new Intl.DateTimeFormat('en-US', { month: 'short', year: 'numeric', timeZone: 'UTC' }).format(new Date(`${value}-01T00:00:00Z`));
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  if (/^\d{4}-\d{2}-\d{2}$/.test(value) && date.toISOString().slice(0, 10) !== value) return value;
  return new Intl.DateTimeFormat('en-US', { dateStyle: 'medium', timeZone: 'UTC' }).format(date);
}
